import AppearOnScroll from "./AppearOnScroll";


function Cta() {
  return (
    <a href='mailto:lisanneverbeet@outlook.com'>
    <AppearOnScroll>
    <div className="flex justify-center rounded-image w-full py-16 px-4 md:px-12 lg:px-32 lg:py-32 overflow-hidden" style={{ backgroundImage: "url('/img/CTA-gradient.png')", backgroundSize: "cover", backgroundPosition: "center", }}>
      
        <div className="group flex flex-col md:flex-row w-full items-center cursor-pointer justify-between gap-8 md:gap-0 ">
       
            <div className="flex flex-col lg:gap-8 items-center font-display font-medium md:font-normal text-3xl md:text-6xl leading-relaxed md:items-start text-white text-center">
              <AppearOnScroll>
              
                <h1>All things start small</h1>
                </AppearOnScroll>
                <AppearOnScroll delay={0.3} >
                <h1>Let's talk</h1>
                </AppearOnScroll>
            </div>
            <AppearOnScroll delay={0.3}>
            <div className="translate-x-[0px]
             group-hover:translate-x-[16px]
            transition-all duration-300 ease-in-out stroke-white">
              <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              stroke="secondary"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icon-tabler-arrow-narrow-right"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M5 12h14" />
              <path d="M15 16l4-4" />
              <path d="M15 8l4 4" />
            </svg>
            </div>
            

            </AppearOnScroll>
        </div>
        
    </div>
    </AppearOnScroll>
    </a>
  )
}

export default Cta;
